import { useContext } from "react";
import { CsValueApiContext } from "../context/CsValueApiContext";
/**
 * Hook for using a simplified value api
 * - requires {@link CsValueController}
 * @category Hook
 * @category CsValue
 * @category API
 * @category
 * @export
 * @returns {CsValueApi}
 */
export function useCsValueApi() {
    return useContext(CsValueApiContext);
}
//# sourceMappingURL=useCsValueApi.js.map